module.exports = __webpack_public_path__ + "img/Coin BankB04.99f80d91.png";